import { useRef, useMemo } from 'react';
import classes from '../ReportResult/ReportResult.module.css';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';
import NewRealPlayHeader from './NewRealPlayHeader';
import NewRealPlayLeftSection from './NewRealPlayLeftSection';
import NewRealPlayRightSection from './NewRealPlayRightSection';
import Transcription from '../ReportResult/Transcription';
const NewReviewQualifiedRoleplay = ({ isLoadingResponse }) => {
  const playerRef = useRef(null);
  const {
    assignment_uuid,
    assigned_by_user,
    selectedScenario,
    persona_name: prospectName,
    persona_image,
  } = RealPlayRecordDataHelper();

  const userName = useMemo(
    () => `${assigned_by_user?.first_name} ${assigned_by_user?.last_name}`,
    [assigned_by_user]
  );

  const handleSeek = (timestamp) => {
    const seconds = parseFloat(timestamp);
    const player = playerRef.current;
    if (player) {
      player.seekTo(seconds, 'seconds');
      player.getInternalPlayer()?.play?.();
    }
  };

  return (
    <div>
      <div className={classes.headerContainer}>
        <NewRealPlayHeader />
      </div>
      <div className={classes.gridContainer}>
        <NewRealPlayLeftSection
          isLoadingResponse={isLoadingResponse}
          playerRef={playerRef}
          handleSeek={handleSeek}
        />
        <NewRealPlayRightSection isLoadingResponse={isLoadingResponse} />
      </div>
      <div className={classes.transcriptionContainer}>
        {/* Transcription*/}
        <Transcription
          assignment_uuid={assignment_uuid}
          scenario_uuid={selectedScenario?.uuid}
          response_uuid={selectedScenario?.response?.uuid}
          clientName={prospectName}
          userName={userName}
          assigned_by_user={assigned_by_user}
          client_profile_pic={persona_image}
        />
      </div>
    </div>
  );
};

export default NewReviewQualifiedRoleplay;
